function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39 3H17C14.2 3 12 5.2 12 8V20C12 22.8 14.2 25 17 25H39C41.8 25 44 22.8 44 20V8C44 5.2 41.8 3 39 3Z",
  fill: "#B3B3B3"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 8H19C18.4 8 18 8.4 18 9C18 9.6 18.4 10 19 10H23C23.6 10 24 9.6 24 9C24 8.4 23.6 8 23 8Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 13H19C18.4 13 18 13.4 18 14C18 14.6 18.4 15 19 15H23C23.6 15 24 14.6 24 14C24 13.4 23.6 13 23 13Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 18H19C18.4 18 18 18.4 18 19C18 19.6 18.4 20 19 20H23C23.6 20 24 19.6 24 19C24 18.4 23.6 18 23 18Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 8H28C27.4 8 27 8.4 27 9C27 9.6 27.4 10 28 10H32C32.6 10 33 9.6 33 9C33 8.4 32.6 8 32 8Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 13H28C27.4 13 27 13.4 27 14C27 14.6 27.4 15 28 15H32C32.6 15 33 14.6 33 14C33 13.4 32.6 13 32 13Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 18H28C27.4 18 27 18.4 27 19C27 19.6 27.4 20 28 20H32C32.6 20 33 19.6 33 19C33 18.4 32.6 18 32 18Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38 7C37.4 7 37 7.4 37 8V20C37 20.6 37.4 21 38 21C38.6 21 39 20.6 39 20V8C39 7.4 38.6 7 38 7Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6 2H4V25H6V2Z",
  fill: "#860935"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.7 4.2L5.8 0.3C5.4 -0.1 4.7 -0.1 4.3 0.3L0.3 4.2C0.1 4.4 0 4.7 0 4.9C0 5.2 0.1 5.4 0.3 5.7C0.7 6.1 1.4 6.1 1.8 5.7L5 2.6L8.2 5.7C8.6 6.1 9.3 6.1 9.7 5.7C10.1 5.3 10.1 4.6 9.7 4.2Z",
  fill: "#860935"
});

function SvgMattressWidth({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 25,
    viewBox: "0 0 44 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default "data:image/svg+xml;base64,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";
export { SvgMattressWidth as ReactComponent };